import { prop } from 'ramda';
import { useDispatch } from 'react-redux';
import { useDataFetch } from 'js/hooks/useDataFetch';
import { useEffect, useCallback } from 'react';
import { useUserSelector } from 'js/store/hooks';
import { setFavoriteGamesAction } from 'js/components/system/App/store/actions';

import * as server from './server';

const fetchFavorites = async () => {
    const { data: { favoriteGames } } = await server.getFavoriteGames();

    return favoriteGames;
};

const useShouldFetch = () => {
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));

    return useCallback(() => isLoggedIn, [isLoggedIn]);
};

export const useSetFavorites = ({ isLoading, data }) => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setFavoriteGamesAction({
            favoriteGames: data,
            isFavoritesFetching: isLoading
        }));
    }, [isLoading, data, dispatch]);
};

export const useResetFavorites = () => {
    const dispatch = useDispatch();
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));

    useEffect(() => {
        if (!isLoggedIn) {
            dispatch(setFavoriteGamesAction({}));
        }
    }, [isLoggedIn, dispatch]);
};

export const useFavorites = () => {
    const shouldFetch = useShouldFetch();

    const [{ isLoading, data }] = useDataFetch({
        fetch: fetchFavorites,
        shouldFetch
    });

    useSetFavorites({ isLoading, data });
    useResetFavorites();
};
